import React from 'react';
import classNames from 'styles/utils/classNames';

export enum BookingTypeEnum {
  DirectOnBounce = 'direct',
  ExternalLink = 'external',
}

interface BookingTypeSwitchProps {
  activeType: BookingTypeEnum;
  onTypeChange: (type: BookingTypeEnum) => void;
  className?: string;
}

const BookingTypeSwitch: React.FC<BookingTypeSwitchProps> = ({
  activeType,
  onTypeChange,
  className,
}) => {
  return (
    <div
      className={classNames(
        'relative flex h-10 w-full flex-col items-center justify-center whitespace-nowrap rounded-full bg-color-bg-lightmode-invert-secondary p-1 dark:bg-color-bg-darkmode-invert-secondary',
        className,
      )}
    >
      <div className="relative flex w-full flex-1 justify-center">
        {/* Active Tab Highlight */}
        <div
          className={classNames(
            'absolute bottom-0 left-0 top-0 h-full w-1/2 rounded-full bg-color-bg-lightmode-brand shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.06)] transition-transform duration-300',
            activeType === BookingTypeEnum.DirectOnBounce ? 'translate-x-0' : 'translate-x-full',
          )}
        />

        {/* Direct on Bounce Tab */}
        <button
          onClick={() => onTypeChange(BookingTypeEnum.DirectOnBounce)}
          className={classNames(
            'typography-product-button-label-medium z-10 flex min-w-0 flex-1 items-center justify-center rounded-full px-6 transition-colors duration-300',
            activeType === BookingTypeEnum.DirectOnBounce
              ? 'text-color-text-lightmode-invert dark:text-color-text-lightmode-invert'
              : 'text-color-text-lightmode-invert dark:text-color-text-darkmode-secondary',
          )}
        >
          Direct Bookings
        </button>

        {/* External booking link Tab */}
        <button
          onClick={() => onTypeChange(BookingTypeEnum.ExternalLink)}
          className={classNames(
            'typography-product-button-label-medium z-10 flex min-w-0 flex-1 items-center justify-center rounded-full px-6 transition-colors duration-300',
            activeType === BookingTypeEnum.ExternalLink
              ? 'text-color-text-lightmode-invert dark:text-color-text-lightmode-invert'
              : 'text-color-text-lightmode-invert dark:text-color-text-darkmode-secondary',
          )}
        >
          External Bookings
        </button>
      </div>
    </div>
  );
};

export default BookingTypeSwitch;
